<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>

    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th> {{$t('account.com.type')}} </b-th>
            <b-th> {{$t('account.com.trackingTime')}}  </b-th>
            <b-th> {{$t('account.com.dailyTime')}} </b-th>
            <b-th> {{$t('account.com.callerId')}}  </b-th>
            <b-th> {{$t('account.com.maxSignal')}}  </b-th>
            <b-th> {{$t('account.com.lastSignalTime')}}  </b-th>
            <b-th> {{$t('account.com.lastTestTime')}}  </b-th>
            <b-th> {{$t('account.com.lastCallerId')}} </b-th>
            <b-th> {{$t('account.user.operations')}} </b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="com in communications" :key="com.id">
                <b-td> 
                    <p v-if="com.com_type == 0"> {{$t('account.com.gprs')}} </p>
                    <p v-else-if="com.com_type == 1"> {{$t('account.com.pstn')}} </p>
                    <p v-else-if="com.com_type == 2"> {{$t('account.com.ethernet')}} </p>
                 </b-td>
                <b-td> {{com.tracking_time}} </b-td>
                <b-td> {{momentOnlyHours(com.daily_test_time)}} </b-td>
                <b-td> {{com.system_caller_id}} </b-td>
                <b-td> {{com.max_signal_count}} </b-td>
                <b-td> {{moment(com.last_signal_time)}} </b-td>
                <b-td> {{moment(com.last_test_time)}} </b-td>
                <b-td> {{com.last_phone_no}} </b-td>
                <b-td> 
                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true"  @click="openModal('edit', com)"  ></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal('delete', com)"></b-icon>
                </b-td>

            </b-tr>
            
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: "TracingForm",
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            openModal:function(name, data){
                this.modalType(true, 'Communications', 8)
                this.modalEvent(true, name, data)
            },
            moment: function(data){
                return moment(data).format('DD MMMM YYYY HH:mm');
            },
            momentOnlyHours: function(data){
                return moment(data).format('HH:ss');
            },
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            communications(){
                return this.$store.getters.getAccountCommunications
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/Communication.vue